import { Skeleton } from "@/components/ui/skeleton";
import type { FpProject } from "../../../schemas";
import { EmptyProjectsState } from "./EmptyProjectsState";
import { ProjectCard } from "./ProjectCard";

interface ProjectsGridProps {
  projects: FpProject[];
  isLoading?: boolean;
}

export function ProjectsGrid({ projects, isLoading }: ProjectsGridProps) {
  if (isLoading) {
    return (
      <div className="@container w-full">
        <div className="grid grid-cols-1 @lg:grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-4">
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
          <ProjectCardSkeleton />
        </div>
      </div>
    );
  }

  if (projects.length === 0) {
    return <EmptyProjectsState />;
  }

  return (
    <div className="@container w-full">
      <div className="grid grid-cols-1 @lg:grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-4">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
}

function ProjectCardSkeleton() {
  return (
    <div className="@container rounded-xl border bg-card shadow">
      {/* Mobile skeleton */}
      <div className="@lg:hidden flex flex-col">
        <div className="p-4 pb-3">
          <div className="flex items-start justify-between gap-2 mb-2">
            <Skeleton className="h-5 w-32 flex-1" />
            <Skeleton className="h-5 w-16 flex-shrink-0" />
          </div>
          <Skeleton className="h-4 w-48" />
        </div>
        <div className="border-t px-4 py-3">
          <div className="flex justify-center">
            <Skeleton className="h-3 w-12" />
          </div>
        </div>
      </div>

      {/* Desktop skeleton */}
      <div className="hidden @lg:block p-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="border-t pt-3 flex justify-center">
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      </div>
    </div>
  );
}
